import { UseIframeOptions } from '@/types/iframe';

export function useIframe(iframeKey: string, options: UseIframeOptions = {}) {
  const iframeRef = useTemplateRef<HTMLIFrameElement>(iframeKey);

  const { onMessage, onLoad, onError } = options;

  const isLoading = ref<boolean>(true);
  const isError = ref<boolean>(false);

  const handleLoad = () => {
    isLoading.value = false;
    isError.value = false;

    if (onLoad) {
      onLoad();
    }
  };

  const handleError = (event: Event) => {
    isLoading.value = false;
    isError.value = true;

    if (onError) {
      onError(event);
    }
  };

  const handleMessage = (event: MessageEvent) => {
    if (onMessage) {
      onMessage(event.data);
    }
  };

  onMounted(() => {
    window.addEventListener('message', handleMessage);

    const el = iframeRef.value;
    if (el) {
      el.addEventListener('load', handleLoad);
      el.addEventListener('error', handleError);
    }
  });

  onBeforeUnmount(() => {
    window.removeEventListener('message', handleMessage);

    const el = iframeRef.value;
    if (el) {
      el.removeEventListener('load', handleLoad);
      el.removeEventListener('error', handleError);
    }
  });

  return {
    iframeRef,
    isLoading,
    isError,
  };
}
